import { METHOD_TEMPLATES } from "../utils/consts";
import { generateAnyMethod, generateCustomMethod } from "./any";
import { generateCreateMethod, generateDeleteMethod, generateGetMethod, generateUpdateMethod } from "./crud";
import { generateEmptyMethod } from "./empty";
import { generateInitMethod } from "./init";
import { generateDBListCountMethod, generateDeleteSelectedMethod, generateListItemCopyMethod, generateListOrCountMethod, generateNewItemMethod, generateSaveMethod, generateSaveSelectedMethod } from "./list";
import { generateLocalListGetAllData, generateLocalListInit, generateLocalListList } from "./localList";
import { generateProdListMethod, generateListWithStatusMethod, generatePublishMethod, generateDeleteOpListMethod, generatePublishDeleteOpMethod, generateHistoryListMethod, generateRollbackMethod, generateUnpublishedListMethod, generateProdCountMethod, generateDeleteOpCountMethod, generateHistoryCountMethod, generatePublishedListMethod, generatePublishedCountMethod, generateUnpublishedCountMethod } from "./version/prodList";
import { generateGetPublishStatusMethod } from "./version/form";
const mt = METHOD_TEMPLATES;
export const generators = [{
  generate: generateInitMethod,
  title: '初始化(系统方法)',
  tpls: [mt.list.init, mt.form.init, mt.any.init]
}, {
  generate: generateCreateMethod,
  title: '创建(create)',
  tpls: [mt.list.create, mt.form.create],
  cgis: ['create', 'create']
}, {
  generate: generateUpdateMethod,
  title: '更新(update)',
  tpls: [mt.list.update, mt.form.update],
  cgis: ['update', 'update']
}, {
  generate: generateGetMethod,
  title: '获取(get)',
  tpls: [mt.list.get, mt.form.get],
  cgis: ['get', 'get']
}, {
  generate: generateDeleteMethod,
  title: '删除(delete)',
  tpls: [mt.list.delete, mt.form.delete],
  cgis: ['delete', 'delete']
}, {
  generate: generateDBListCountMethod,
  title: '获取列表数据(同时请求list和count接口)',
  tpls: [mt.list.listCount],
  cgis: ['list']
}, {
  generate: generateListOrCountMethod,
  title: '获取列表数据(list)',
  tpls: [mt.list.list],
  cgis: ['list']
}, {
  generate: generateListOrCountMethod,
  title: '获取总数(count)',
  tpls: [mt.list.count],
  cgis: ['count']
}, {
  generate: generateSaveMethod,
  title: '保存(save)',
  tpls: [mt.list.save]
}, {
  generate: generateNewItemMethod,
  title: '新建一行空数据,不提交(newItem)',
  tpls: [mt.list.newItem]
}, {
  generate: generateSaveSelectedMethod,
  title: '批量-保存已选中行(saveSelected)',
  tpls: [mt.list.saveSelected]
}, {
  generate: generateDeleteSelectedMethod,
  title: '批量-删除已选中行(deleteSelected)',
  tpls: [mt.list.deleteSelected]
}, {
  generate: generateListItemCopyMethod,
  title: '复制数据(copy)',
  tpls: [mt.list.copy]
}, {
  generate: generateEmptyMethod,
  title: '空白方法',
  tpls: [mt.empty]
}, {
  generate: generateAnyMethod,
  title: '请求(request)',
  tpls: [mt.any.request],
  cgis: ['request']
}, {
  generate: generateLocalListInit,
  title: '本地分页初始化(init)',
  tpls: [mt.list.local_init]
}, {
  generate: generateLocalListGetAllData,
  title: '请求所有数据(getAllData)',
  tpls: [mt.list.local_getAllData],
  cgis: ['list']
}, {
  generate: generateLocalListList,
  title: '设置分页数据(list)',
  tpls: [mt.list.local_list]
},
// 以下是行级版本特有方法
{
  generate: generateProdListMethod,
  title: '正式表列表(prodList)',
  tpls: [mt.list.prodList]
}, {
  generate: generateListWithStatusMethod,
  title: '获取带状态的列表(listWithStatus)',
  tpls: [mt.list.listWithStatus]
}, {
  generate: generateGetPublishStatusMethod,
  title: '获取发布状态(getPublishStatus)',
  tpls: [mt.form.getPublishStatus]
}, {
  generate: generatePublishMethod,
  title: '发布(publish)',
  tpls: [mt.list.publish, mt.form.publish]
}, {
  generate: generateDeleteOpListMethod,
  title: '删除记录(deleteOpList)',
  tpls: [mt.list.deleteOpList]
}, {
  generate: generatePublishDeleteOpMethod,
  title: '发布删除(publishDeleteOp)',
  tpls: [mt.list.publishDeleteOp]
}, {
  generate: generateHistoryListMethod,
  title: '获取历史版本(historyList)',
  tpls: [mt.list.historyList, mt.form.historyList]
}, {
  generate: generateRollbackMethod,
  title: '回滚(rollback)',
  tpls: [mt.list.rollback, mt.form.rollback]
}, {
  generate: generateUnpublishedListMethod,
  title: '获取未发布的列表(unpublishedList)',
  tpls: [mt.list.unpublishedList]
}, {
  generate: generateProdCountMethod,
  title: '获取正式表总数(prodCount)',
  tpls: [mt.list.prodCount]
}, {
  generate: generateDeleteOpCountMethod,
  title: '获取删除记录总数(deleteOpCount)',
  tpls: [mt.list.deleteOpCount]
}, {
  generate: generateHistoryCountMethod,
  title: '获取删除记录总数(historyCount)',
  tpls: [mt.list.historyCount, mt.form.historyCount]
}, {
  generate: generatePublishedListMethod,
  title: '获取已发布列表(publishedList)',
  tpls: [mt.list.publishedList]
}, {
  generate: generatePublishedCountMethod,
  title: '获取已发布总数(publishedCount)',
  tpls: [mt.list.publishedCount]
}, {
  generate: generateUnpublishedCountMethod,
  title: '获取未发布总数(unpublishedCount)',
  tpls: [mt.list.unpublishedCount]
}];
export const methodGeneratorMap = generators.reduce((prev, item) => {
  item.tpls.forEach((t, index) => {
    var _item$cgis;
    const g = {
      generate: item.generate,
      title: item.title,
      tpl: t,
      cgi: (_item$cgis = item.cgis) === null || _item$cgis === void 0 ? void 0 : _item$cgis[index]
    };
    prev[t] = g;
  });
  return prev;
}, {});
export function getMethodGenerator(tpl) {
  return methodGeneratorMap[tpl];
}
export function getCustomMethodGenerator(cgi) {
  const g = {
    generate: generateCustomMethod,
    title: '请求',
    tpl: mt.custom,
    cgi
  };
  return g;
}
//# sourceMappingURL=generators.js.map
